const initialState = {
  organizationsInfo: [],
  netError: null
};

export default (state = initialState, action) => {
  let currentState = state;
  switch (action.type) {
    case "FETCH_ORGANIZATIONS_SUCCESS":
      currentState = { ...state, organizationsInfo: action.payload, netError: null };
      break;

    case "FETCH_ORGANIZATIONS_FAILURE":
      currentState = { ...state, netError: action.error };
      break;

    default:
  }
  return currentState;
};
